function isHellolesley() {
  const href = window.location.href;
  return (href || '').toLowerCase().indexOf('hellolesley') !== -1;
}

export default isHellolesley;
